export const FAQ_BLOCK_s3 = {
  "blockType": "FAQ",
  "blockDesign": "FAQDesign1",
  "editFormName": "FAQ_FORM_1",
  "styleProps": {
    "background-color": "#ffffff",
    "background-image": "url('')",
    "padding": "120px 20px 120px 20px"
  },
  "sectionConfigs": {
    "headerTextStyleProps": {
      "font-size": "1.25rem",
      "line-height": "1.75rem",
      "font-weight": "500",
      "padding": "14px 30px 14px 30px",
      "color": "#333333"
    },
    "bodyTextStyleProps": {
      "padding": "14px 30px 14px 30px",
      "color": ""
    },
    "sectionStyleProps": {
      "backgroundColor": "#f8f8f8",
      "padding": "10px",
      "border-width": "2px",
      "border-radius": "1.5rem",
      "border-color": "#DDDACC",
      "margin": "0px 0px 8px 0px",
      "background-color": "#FBFAF9"
    }
  },
  "headings": [
    {
      "text": "BECOME A MEMBER",
      "styleProps": {
        "font-weight": "500",
        "text-align": "center",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 20px 0px",
        "margin": "0px 20px 0px 20px"
      },
      "alignStyleProps": {
        "text-align": "center"
      }
    },
    {
      "text": "Got questions? We've got answers.",
      "styleProps": {
        "text-align": "center",
        "font-size": "3rem",
        "line-height": "1",
        "font-family": "'Playfair Display'",
        "font-weight": "500",
        "padding": "0px 0px 20px 0px",
        "margin": "0px 20px 80px 20px",
        "font-family-cust": "Playfair Display"
      },
      "alignStyleProps": {
        "text-align": "center"
      }
    }
  ],
  "list": [
    {
      "headerText": "What subscription tiers can I subscribe to with flezr?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "How much does a subscription to faq cost, and for how long can I subscribe?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "Can we use the code/art/assets in Flezr Technologies' example projects?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    }
  ],
  "metaDataId": 1746181627035,
  "afterIndex": 30,
  "blockId": 1746181627035,
  "fonts": {
    "headings": [
      null,
      "Playfair Display"
    ]
  },
  "containerStyleProps": {
    "padding": "0px 20px 0px 20px",
    "max-width": "800px"
  }
}